import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { getSoftwareByCategory } from '@/utils/catalog';

export default function CategoryQuickNav() {
  return (
    <section className="mx-auto max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
      <div className="mb-8 flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">软件分类导航</h2>
          <p className="mt-1.5 text-sm text-foreground-500">按系统平台与软件类型快速定位你需要的看片工具</p>
        </div>
        <Link
          to="/search"
          className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          浏览全部软件
          <i className="ri-arrow-right-s-line text-base"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((cat) => {
          const count = getSoftwareByCategory(cat.id).length;
          return (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-primary-50/40"
            >
              <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-background-50 transition-colors group-hover:bg-primary-600">
                <i className={`${cat.icon} text-2xl`}></i>
              </span>
              <span className="min-w-0 flex-1">
                <span className="flex items-center justify-between gap-2">
                  <span className="text-base font-semibold text-foreground-900 group-hover:text-primary-700">
                    {cat.name}
                  </span>
                  <span className="shrink-0 rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-800">
                    {count} 款
                  </span>
                </span>
                <span className="mt-1.5 line-clamp-2 text-sm leading-relaxed text-foreground-500">
                  {cat.description}
                </span>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}